import Vue from 'vue';
import urlVal from '../urlVal.js'
import VueI18n from 'vue-i18n'
import enFile from './en_i18n.js';
import zhHant from './zh-Hant_i18n.js';
const navLang = navigator.language || navigator.userLanguage;  
let localLang = 'zh'; // 默认设置
if (navLang.startsWith('en')) {  
  localLang = 'en'; // 如果是中文，则设置为中文  
};
if(urlVal().lang){
  localLang = urlVal().lang||localLang;//根据参数调整
  window.sessionStorage.setItem(`lang`,localLang);
};
localLang = window.sessionStorage.getItem(`lang`)||localLang;
Vue.use(VueI18n);//使用国际化//<静态此处可以不用
const i18nx = new VueI18n({  
    locale: localLang, // 根据浏览器语言设置locale  
    // locale: `en`, // 此处强制en  
    fallbackLocale: 'zh',//默认语言
    silentTranslationWarn: true, // 关闭翻译警告  
    silentFallbackWarn: true, // 当某个语言环境缺少翻译时，关闭回退警告 
    messages: {  
        zh: { /* 中文翻译内容 */ },  
        en: { /* 英文翻译内容 */...enFile, },
        "zh-Hant": { /* 繁体中文 */...zhHant, },
    }  
});

export default i18nx;//放到vue对象内


// WEBPACK FOOTER //
// ./src/vuex/i18n/i18n.js